<div class="body" [ngClass]="{
    'tb-none': widgetComponentService.widgetBarPosition === WidgetBarPosition.None,
    'tb-top': widgetComponentService.widgetBarPosition === WidgetBarPosition.Top,
    'tb-right': widgetComponentService.widgetBarPosition === WidgetBarPosition.Right,
    'tb-bottom': widgetComponentService.widgetBarPosition === WidgetBarPosition.Bottom,
    'tb-left': widgetComponentService.widgetBarPosition === WidgetBarPosition.Left,
    'drrz-mode': (widgetViewStandaloneComponentService.viewMode$|async) === WidgetViewStandaloneModes.DRAG_AND_RESIZE_MODE
}">
    <div *ngIf="(widgetViewStandaloneComponentService.viewMode$|async) === WidgetViewStandaloneModes.DRAG_AND_RESIZE_MODE" class="drrz-overlay"></div>
    <div *ngIf="(widgetViewStandaloneComponentService.viewMode$|async) === WidgetViewStandaloneModes.DELETE_MODE" class="delete-overlay" (click)="deleteWidget()">
        <span class="spacer"></span>
        <mat-icon class="icon">delete_forever</mat-icon>
        <span class="spacer"></span>
    </div>
    <div class="toolbar" [ngClass]="{
        'none': widgetComponentService.widgetBarPosition === WidgetBarPosition.None,
        'top': widgetComponentService.widgetBarPosition === WidgetBarPosition.Top,
        'right': widgetComponentService.widgetBarPosition === WidgetBarPosition.Right,
        'bottom': widgetComponentService.widgetBarPosition === WidgetBarPosition.Bottom,
        'left': widgetComponentService.widgetBarPosition === WidgetBarPosition.Left
    }">
        <div *ngIf="rightsMap.edit_dashboard" class="option" matTooltip="Widgetmenü öffnen" (click)="openWidgetMenu()">
            <mat-icon class="icon">
                {{widgetIcon}}
            </mat-icon>
        </div>

        <ng-container *ngFor="let uFilter of (widgetComponentService.widget$|async).widgetuserfilters">
            <div class="option" [style.backgroundColor]="uFilter.filterbackgroundcolor? uFilter.filterbackgroundcolor : defaultUserFilterBackgroundColor" matTooltip="{{uFilter.filteR1? uFilter.filtertext: uFilter.filtertext + ' - keine Kriterien hinterlegt'}}" (click)="userFilterClicked(uFilter)">
                <mat-icon class="icon" [style.color]="uFilter.filtercolor? uFilter.filtercolor : defaultUserFilterColor" >
                    {{uFilter.filtericon? uFilter.filtericon : defaultUserFilterIcon}}
                </mat-icon>
            </div>
        </ng-container>

        <ng-container *ngIf="widgetComponentService.widgetInnerViews.length > 0">
            <div class="option calendar-view" *ngFor="let view of widgetComponentService.widgetInnerViews" [style.backgroundColor]="view.color? (view.color()|async) : defaultChildViewControlBackgroundColor" matTooltip={{view.name()|async}} (click)="widgetInnerViewClicked(view)">
                <mat-icon class="icon">
                    {{view.icon()|async}}
                </mat-icon>
            </div>
        </ng-container>

        <ng-container *ngIf="widgetComponentService.chartViews.length > 0">
            <div class="option chart-view" *ngFor="let view of widgetComponentService.chartViews" matTooltip={{view.name}} (click)="chartViewClicked(view)">
                <mat-icon class="icon">
                    pie_chart
                </mat-icon>
            </div>
        </ng-container>
        
        <ng-container *ngIf="widgetComponentService.iFrameViews.length > 0">
            <div class="option iframe-view" *ngFor="let href of widgetComponentService.iFrameViews" (click)="iFrameClicked(href)" [matTooltip]="href">
                <mat-icon class="icon">
                    language
                </mat-icon>
            </div>
        </ng-container>

    </div>

    <ng-container *ngIf="widgetComponentService.widgetBarPosition === WidgetBarPosition.None">
        <div class="no-toolbar-menu-trigger" [matMenuTriggerFor]="menu">
            <mat-icon class="icon">
                more_horiz
            </mat-icon>
        </div>
    </ng-container>
    
    <div class="content" [class.auto-refresh]="refreshSub" [class.refreshing]="refreshing$|async">
        
        <ng-container #widgetInner></ng-container>

    </div>

</div>

<mat-menu #menu="matMenu">
    <button *ngIf="rightsMap.edit_dashboard" mat-menu-item class="dropdown-item" (click)="openWidgetMenu()">
        <mat-icon class="dropdown-icon">
            {{widgetIcon}}
        </mat-icon>
        <span>Menü</span>
    </button>

    <ng-container *ngFor="let uFilter of (widgetComponentService.widget$|async).widgetuserfilters">
        <button mat-menu-item class="dropdown-item" (click)="userFilterClicked(uFilter)">
            <mat-icon class="dropdown-icon">
                {{uFilter.filtericon? uFilter.filtericon : defaultUserFilterIcon}}
            </mat-icon>
            <span>
                {{uFilter.filteR1? uFilter.filtertext: uFilter.filtertext + ' - keine Kriterien hinterlegt!'}}
            </span>
        </button>
    </ng-container>

    <ng-container *ngFor="let view of widgetComponentService.widgetInnerViews">
        <button mat-menu-item class="dropdown-item" (click)="widgetInnerViewClicked(view)">
            <mat-icon class="dropdown-icon">
                {{view.icon()|async}}
            </mat-icon>
            <span>
                {{view.name()|async}}
            </span>
        </button>
    </ng-container>

    <ng-container *ngIf="widgetComponentService.chartViews.length > 0">
        <ng-container *ngFor="let view of widgetComponentService.chartViews">
            <button mat-menu-item class="dropdown-item" (click)="chartViewClicked(view)">
                <mat-icon class="dropdown-icon">
                    pie_chart
                </mat-icon>
                <span>
                    {{view.name}}
                </span>
            </button>
        </ng-container>
    </ng-container>

</mat-menu>